/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagPercentile } from '../../models/tag-percentile';

export interface ComputePercentile$Params {

/**
 * The uid of the selected tag
 */
  tagUid: string;

/**
 * You can set multiple fractions, you have to repeat the parameter fraction. 0.5 to return median value
 */
  fraction: Array<number>;

/**
 * Duration in days
 */
  durationInDays: number;
}

export function computePercentile(http: HttpClient, rootUrl: string, params: ComputePercentile$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TagPercentile>>> {
  const rb = new RequestBuilder(rootUrl, computePercentile.PATH, 'get');
  if (params) {
    rb.path('tagUid', params.tagUid, {});
    rb.query('fraction', params.fraction, {"style":"form","explode":true});
    rb.query('durationInDays', params.durationInDays, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TagPercentile>>;
    })
  );
}

computePercentile.PATH = '/tags/{tagUid}/percentiles';
